import { Injectable } from "@angular/core";
import { Angulartics2, Angulartics2Mixpanel, Angulartics2GoogleAnalytics } from 'angulartics2';
import { UserInfoService } from '../auth/user-info.service';
import { ScriptLoaderService } from '../utility/script-loader.service';

declare var gtag: any;

@Injectable()
export class EcapCoreAnalyticsService {
    private dimensionMap: any;
    private sessionStartTime: any;

    constructor(private angulartics2Mixpanel: Angulartics2Mixpanel,
                private angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics,
                private userInfoService: UserInfoService,
                private scriptLoaderService: ScriptLoaderService,
                private angulartics2: Angulartics2) {
    }

    /**
     * setting dimemsions mapping
     * @param dimension
     */
    private registerDimensionsMap(dimension) {
        this.dimensionMap = dimension;
    }

    setSessionStartTime(time) {
        this.sessionStartTime = time;
    }

    getSessionStartTime() {
        return this.sessionStartTime;
    }

    /**
     * tracking events
     * @param action
     * @param label
     * @param category
     * @param dimensions
     */
    eventTrack(action, label, category, dimensions?, userId?:string) {
        const properties = {
            userId: userId || this.userInfoService.userInfo["UserId"],
            label: label,
            category: category
        }

        if (dimensions) {
            Object.keys(dimensions).forEach((element) => {
              if(this.dimensionMap[element]){
                const dimensionValue = 'dimension' + this.dimensionMap[element];
                properties[dimensionValue] = dimensions[element];
              }
            });
        }

        this
            .angulartics2
            .eventTrack
            .next({
                action: action,
                properties: properties
            });
    }

    eventTrackWithGTag(action, label, category, dimensions?, userId?:string) {
      const properties = {
          userId: userId || this.userInfoService.userInfo["UserId"],
          label: label,
          category: category
      }

      if (dimensions) {
          Object.keys(dimensions).forEach((element) => {
            if(this.dimensionMap[element]){
              const dimensionValue = 'dimension' + this.dimensionMap[element];
              properties[dimensionValue] = dimensions[element];
            }
          });
      }
      this.eventTrackByGTag(action, properties);
    }

    /**
     * Initializing analytics fr the site
     * @param dimensionMap
     */
    initializeAnalytics(dimensionMap?) {
        this.registerDimensionsMap(dimensionMap);
        const tenantInfo = this.userInfoService.getTenantInfo();
        if (tenantInfo && tenantInfo.AnalyticsProvider) {
            this.scriptLoaderService.load([tenantInfo.AnalyticsProvider], tenantInfo.AnalyticsTrackingId).then(data => {
                this.startTracking(tenantInfo.AnalyticsProvider); // start tracking
                console.log(tenantInfo.AnalyticsProvider + ' script loaded ', data);
            }).catch(error => console.log(error));
        }
        else {
            this.userInfoService.getIdentity().subscribe((response) => {
                if (response && response.AnalyticsProvider) {
                    this.scriptLoaderService.load([response.AnalyticsProvider], response.AnalyticsTrackingId).then(data => {
                        this.startTracking(response.AnalyticsProvider); // start tracking
                        console.log(response.AnalyticsProvider + ' script loaded ', data);
                    }).catch(error => console.log(error));
                }
            });
        }
    }

    initializeAnalyticsForGTag(dimensionMap?, userId?:string) {
      this.registerDimensionsMap(dimensionMap);
      const tenantInfo = this.userInfoService.getTenantInfo();
      if (tenantInfo && tenantInfo.AnalyticsProvider) {
          this.scriptLoaderService.loadGTag([tenantInfo.AnalyticsProvider], tenantInfo.AnalyticsTrackingId, userId).then(data => {
            this.startTracking(tenantInfo.AnalyticsProvider); // start tracking
              console.log(tenantInfo.AnalyticsProvider + ' GTag script loaded ', data);
          }).catch(error => console.log(error));
      }
      else {
          this.userInfoService.getIdentity().subscribe((response) => {
              if (response && response.AnalyticsProvider) {
                  this.scriptLoaderService.loadGTag([response.AnalyticsProvider], response.AnalyticsTrackingId).then(data => {
                      this.startTracking(response.AnalyticsProvider); // start tracking
                      console.log(response.AnalyticsProvider + ' GTag script loaded ', data);
                  }).catch(error => console.log(error));
              }
          });
      }
    }

    /**
     * starting to track the site
     * @param type
     */
    startTracking(type) {
        if (type == 'MixPanel')
            this.angulartics2Mixpanel.startTracking();
        if (type == 'google-analytics')
            this.angulartics2GoogleAnalytics.startTracking();
    }

    /**
     * set user properties
     * @param properties
     */
    setUserProperties(properties:any) {
      this.angulartics2.setUserProperties.next(properties);
    }

    // setUsernameForGTag(userId: string | { userId: string | number }) {
    //   this.angulartics2Core.settings.gst.userId = userId;
    //   if (typeof gtag !== 'undefined' && gtag) {
    //     gtag('set', { user_id: typeof userId === 'string' || !userId ? userId : userId.userId });
    //   }
    // }

    private eventTrackByGTag(action: string, properties: any = {}) {
      this.eventTrackInternal(action, {
        event_category: properties.category || 'interaction',
        event_label: properties.label,
        value: properties.value,
        non_interaction: properties.noninteraction,
        ...properties.gstCustom,
      });
    }

    private eventTrackInternal(action: string, properties: any = {}) {
      this.cleanProperties(properties);
      if (typeof gtag !== 'undefined' && gtag) {
        gtag('event', action, properties);
      }
    }

    private cleanProperties(properties: { [key: string]: any }): void {
      // GA requires that eventValue be an non-negative integer, see:
      // https://developers.google.com/analytics/devguides/collection/gtagjs/events
      if (properties.value) {
        const parsed = parseInt(properties.value, 10);
        properties.value = isNaN(parsed) ? 0 : parsed;
      }
    }
}
